// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2958":"f9578814","4965":"3f16b435","7204":"dac54101","8113":"3a45b0ec","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};